import { render } from "./MenuButton.vue?vue&type=template&id=0e65e662"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=0e65e662&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__